import { useState } from 'react';
import { useTranslation } from "react-i18next";
import './login.scss';
import LoginErrorComponent from '../loginError/loginError';
interface ILoginComponentProps {
    loginError: string;
    doLogin: (values: any) => void;
    loading?: boolean;
}

const LoginComponent = (props: ILoginComponentProps) => {
    const { t } = useTranslation('browser');
    const [nameValue, setNameValue] = useState('');
    const [passwordValue, setPasswordValue] = useState('');
    const [checkboxValue, setCheckboxValue] = useState(false);
    const handleLogin = () => {
        props.doLogin({
            "nameInput": nameValue,
            "password": passwordValue,
            "remember": checkboxValue
        });
    };
    const checkButtonActive = () => {
        return passwordValue && nameValue
    }
   
    return (
        <div className="login-component-container">
            <div className="login-form">
                <div className="form-tr">
                    <p>{ t('LOGIN_USERNAME') }</p>
                    <input
                        className="ctx-input"
                        key="nameInput"
                        required
                        placeholder={t('LOGIN_USERNAME_HINT') || ''}
                        value={nameValue}
                        onChange={event => setNameValue(event.target.value)}
                    />
                </div>
                <div className="form-tr">
                    <p>{ t('LOGIN_PASSWORD')}</p>
                    <input
                        className="ctx-input"
                        type="password"
                        key="password"
                        placeholder=''
                        required
                        value={passwordValue}
                        onChange={event => setPasswordValue(event.target.value)}
                    />
                </div>
                <div className="login-group">
                    <input type='checkbox' id="loginCheckbox" checked={checkboxValue} onChange={e => setCheckboxValue(e.target.checked)}/>
                    <label htmlFor="loginCheckbox">{ t('LOGIN_REMEMBERME') }</label>
                </div>
                {   
                    props?.loginError && <div><LoginErrorComponent errMessage={ props.loginError }/></div>
                }
                <button
                    className={`${checkButtonActive() ? 'ctx-button-active' : 'ctx-button-disabled'} button submit-btn login-button ctx-button`}
                    disabled={!checkButtonActive()}
                    onClick={handleLogin}>
                        {t('LOGIN_BUTTON')}
                </button>
            </div>
            <div id="recaptcha-container"></div>
        </div>
    )
}

export default LoginComponent;